import { useState, useEffect, useRef } from 'react';

import { useFiltersContext } from '@spotahome/ui-library';

import { Mediator } from '@spotahome/soyuz-mediator';

import {
  SEO_FILTERS_CLOSE,
  SEO_FILTERS_OPEN
} from '../../common/utils/channels';

import Filters from '../Filters';

import './FiltersWrapper.scss';
import FiltersHeader from '../FiltersHeader/FiltersHeader';
import { useSeoTotalSearchResults } from '../../context/SeoSearchContext';

const FiltersWrapper = props => {
  const [open, setOpen] = useState(false);
  const filtersElem = useRef(null);
  const { filters, handleUpdateFilters } = useFiltersContext();
  const totalMarkers = useSeoTotalSearchResults();

  useEffect(() => {
    const handleFiltersOpen = () => {
      setOpen(true);
      document.body.style.overflow = 'hidden';
    };

    Mediator.subscribe(SEO_FILTERS_OPEN, handleFiltersOpen);

    return () => {
      Mediator.unsubscribe(SEO_FILTERS_OPEN, handleFiltersOpen);
    };
  }, []);

  const handleFiltersClose = () => {
    setOpen(false);
    document.body.style.overflow = 'visible';
    Mediator.publish(SEO_FILTERS_CLOSE);
  };

  const handleFiltersUpdate = filtersToBeMerged => {
    handleUpdateFilters({
      ...filters,
      ...filtersToBeMerged
    });
  };

  useEffect(() => {
    const handleBackdropClick = e => {
      if (
        open &&
        filtersElem.current &&
        !filtersElem.current.contains(e.target)
      ) {
        handleFiltersClose();
      }
    };
    if (open) {
      document.addEventListener('click', handleBackdropClick);
    } else {
      document.removeEventListener('click', handleBackdropClick);
    }

    return () => {
      document.removeEventListener('click', handleBackdropClick);
    };
  }, [open]);

  return open ? (
    <div className="filters-wrapper">
      <div ref={filtersElem}>
        <Filters
          {...props}
          onFiltersUpdate={handleFiltersUpdate}
          onClearFilters={() => {}}
          onCloseFilters={handleFiltersClose}
          activeFiltersCount={0}
        />
        <FiltersHeader
          totalResults={totalMarkers}
          onHandleFiltersToggle={handleFiltersClose}
          isFooterInSearchPage
        />
      </div>
    </div>
  ) : null;
};

export default FiltersWrapper;
